import React, { useEffect } from 'react';
import './home.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

export default function News() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location.state)
    return (
        <div className='news-holder'>
            <img src='./svg-icons/back.svg' alt='' className='cursor-pointer' onClick={() => navigate(-1)} />
            <img src={location.state.data.news_image} alt='' className='banner-img' />
            <div className='news-desc'>
                <div className='publish'>
                    {/* <span>By <a href={location.state.data.sources_link} target='_blank' el="noreferrer">Source</a></span>&nbsp;&nbsp;&nbsp; */}
                    <span>Published on {moment(location.state.data.published_date).format('DD MMM, YYYY')}</span>
                </div>
                <h3>{location.state.data.news_heading}</h3>
                <div dangerouslySetInnerHTML={{ __html: location.state.data.news_content }} />
                <div className='mt-4 text-center'>
                    <button className='read-more'><a href={location.state.data.sources_link} target='_blank' el="noreferrer">Read More...</a></button>
                </div>

            </div>
        </div>
    )
}
